import $foreign from "./foreign.cjs";
var isArray = $foreign.isArray;
var isNull = $foreign.isNull;
var isUndefined = $foreign.isUndefined;
var tagOf = $foreign.tagOf;
var typeOf = $foreign.typeOf;
export { isArray, isNull, isUndefined, tagOf, typeOf };
